import notifee, { AndroidImportance, EventType } from '@notifee/react-native';
import messaging from '@react-native-firebase/messaging';
import Fetch from 'common/helpers/Fetch';
import ApiConst from 'consts/ApiConst';
import { AppState, Platform } from 'react-native';
import Configs from 'utils/Configs';
import Funcs from '../helpers/Funcs';

const maskToken = (token) => (token && token.length > 12 ? `${token.slice(0, 6)}...${token.slice(-6)}` : '***');

export default class PushNotificationService {
  static isInitialized = false;

  static async requestPermission() {
    try {
      if (Platform.OS === 'ios') {
        await messaging().requestPermission();
      } else {
        await notifee.requestPermission();
      }
    } catch (err) {
      Funcs.log('Push notification permission error:', err);
    }
  }

  static async getToken() {
    try {
      if (Platform.OS === 'ios') {
        if (!messaging().isDeviceRegisteredForRemoteMessages) await messaging().registerDeviceForRemoteMessages();
        const apnsToken = await messaging().getAPNSToken();
        if (!apnsToken) return null;
      }
      const fcmId = await messaging().getToken();
      Funcs.log('FCM token:', maskToken(fcmId));
      return fcmId;
    } catch (err) {
      Funcs.log('Get FCM token error:', err);
      return null;
    }
  }

  static async updateDevice(fcmId) {
    try {
      if (!Configs.token || Configs.user?.isStaff) return;
      const token = fcmId || (await PushNotificationService.getToken());
      if (!token) return;
      await Fetch.post(ApiConst.USER.UPDATE_DEVICE, { fcmId: token }, { disableAlert: true });
    } catch (err) {
      Funcs.log('Update FCM device error:', err);
    }
  }

  static async setupAndroidChannel() {
    if (Platform.OS !== 'android') return 'default';
    return notifee.createChannel({ id: 'default', name: 'Thông báo', importance: AndroidImportance.HIGH });
  }

  static async displayLocalNotification(remoteMessage) {
    try {
      const channelId = await PushNotificationService.setupAndroidChannel();
      await notifee.displayNotification({
        title: remoteMessage.notification?.title || 'Thông báo mới',
        body: remoteMessage.notification?.body || '',
        android: { channelId, smallIcon: 'ic_launcher', importance: AndroidImportance.HIGH, pressAction: { id: 'default' } },
        ios: { foregroundPresentationOptions: { alert: true, badge: true, sound: true } }
      });
    } catch (err) {
      Funcs.log('Display FCM notification error:', err);
    }
  }

  // Android launcher đếm badge theo số notification còn trên khay nên phải xóa cả notification đang hiển thị
  static async clearBadge() {
    try {
      await notifee.setBadgeCount(0);
      await notifee.cancelDisplayedNotifications();
    } catch (err) {
      Funcs.log('Clear badge error:', err);
    }
  }

  static onChangeAppState(nextAppState) {
    if (nextAppState === 'active') PushNotificationService.clearBadge();
  }

  static init() {
    if (PushNotificationService.isInitialized) return;
    PushNotificationService.isInitialized = true;
    PushNotificationService.requestPermission();
    PushNotificationService.clearBadge();
    AppState.addEventListener('change', PushNotificationService.onChangeAppState);
    PushNotificationService.unsubscribeTokenRefresh = messaging().onTokenRefresh((fcmId) => PushNotificationService.updateDevice(fcmId));
    PushNotificationService.unsubscribeOnMessage = messaging().onMessage((remoteMessage) => PushNotificationService.displayLocalNotification(remoteMessage));
    PushNotificationService.unsubscribeOnNotificationOpened = messaging().onNotificationOpenedApp((remoteMessage) => Funcs.log('FCM notification opened:', remoteMessage));
    messaging()
      .getInitialNotification()
      .then((remoteMessage) => {
        if (remoteMessage) Funcs.log('FCM notification opened:', remoteMessage);
      });
    PushNotificationService.unsubscribeNotifeeForeground = notifee.onForegroundEvent(({ type, detail }) => {
      if (type === EventType.PRESS) Funcs.log('FCM notification pressed:', detail.notification);
    });
  }
}
